import { OUTreeContent } from '@monorepo/shared/components/OUTree';

export const OuPreSelection = () => {
  return (
    <div className="ou-tree-container">
      <div className="ou-tree-title">{'Make a Selection to Proceed'}</div>
      <OUTreeContent />
    </div>
  );
};
